import { render } from "./DoacoesRealizadas.vue?vue&type=template&id=609c7138&scoped=true&ts=true"
import script from "./DoacoesRealizadas.vue?vue&type=script&lang=ts"
export * from "./DoacoesRealizadas.vue?vue&type=script&lang=ts"

import "./DoacoesRealizadas.vue?vue&type=style&index=0&id=609c7138&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609c7138"]])

export default __exports__